import {
  BarChart10Icon,
  Database02Icon,
  Edit03Icon,
  GitBranch01Icon,
  HomeLineIcon,
  MessageChatCircleIcon,
  MessagePlusCircleIcon,
  Scales01Icon,
  ThumbsUpIcon,
  ZapIcon,
} from '@langchain/untitled-ui-icons';

import GraphFillIcon from '@/Pages/Graph/icons/GraphFillIcon.svg?react';
import ExperimentIcon from '@/icons/ExperimentIcon.svg?react';
import { ResourceType } from '@/types/schema';

export const ICON_MAP = (className: string) => ({
  [ResourceType.Dataset]: <Database02Icon className={className} />,
  [ResourceType.Deployment]: <GraphFillIcon className={className} />,
  [ResourceType.Experiment]: <ExperimentIcon className={className} />,
  [ResourceType.Project]: <GitBranch01Icon className={className} />,
  [ResourceType.Prompt]: <MessagePlusCircleIcon className={className} />,
  [ResourceType.Queue]: <Edit03Icon className={className} />,
  [ResourceType.Dashboard]: <BarChart10Icon className={className} />,
  rule: <ZapIcon className={className} />,
  feedback: <ThumbsUpIcon className={className} />,
  workspace: <HomeLineIcon className={className} />,
  [ResourceType.Evaluator]: <Scales01Icon className={className} />,
  [ResourceType.Conversation]: <MessageChatCircleIcon className={className} />,
});
